const homeHeroTl = gsap.timeline({
	repeat: -1,
	// yoyo: true,
	repeatDelay: 2,
	ease: "power3.in",

});
const maskTl = gsap.timeline({
	repeat: 0,
	// yoyo: true,
	// repeatDelay: 2
	// ease: "power3.in",
	paused: true
});
const windowWidth = window.innerWidth;
const windowHeight = window.innerHeight;
const path = document.querySelector("polygon");

function generateTriangleClipPath() {
  const clipPath = document.getElementById('hero_clip_path');
  if (!clipPath) return;

  // Clear previous triangles
  while (clipPath.firstChild) clipPath.removeChild(clipPath.firstChild);

  const side = window.innerWidth / 2; // side length of triangle
  const width = window.innerWidth + side / 2;
  const height = window.innerHeight;

  const triHeight = Math.sqrt(3) / 2 * side;

  const rows = Math.ceil(height / triHeight) + 1;
  const cols = Math.ceil(width / (side / 2));

  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols; col++) {
      const x = col * (side / 2);
      const y = row * triHeight;
      const up = (row + col) % 2 === 0;

      const points = getTrianglePoints(x, y, side, up);
      const polygon = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
      polygon.setAttribute('points', points.map(p => `${p[0]},${p[1]}`).join(' '));
      polygon.setAttribute('fill', 'black'); // color doesn’t matter in clipPath
      clipPath.appendChild(polygon);
    }
  }
}

function getTrianglePoints(x, y, side, up) {
  const h = Math.sqrt(3) / 2 * side;
  if (up) {
    return [
      [x, y],
      [x + side / 2, y + h],
      [x - side / 2, y + h]
    ];
  } else {
    return [
      [x, y + h],
      [x + side / 2, y],
      [x - side / 2, y]
    ];
  }
}

// window.addEventListener('resize', generateTriangleClipPath);
window.addEventListener('DOMContentLoaded', () => {
	generateTriangleClipPath();
	const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
	if (!prefersReducedMotion.matches) {
		console.log("user not preferes reduced motion")
		maskTl.from('#hero_clip_path polygon', {scale: 0, duration: 0.5, transformOrigin: '50% 50%', stagger: 0.1});
		homeHeroTl.from('.image-back', { x: -100, opacity: 0, duration: 3, stagger:
			{
				each: 5,
				onStart() {
					this.targets()[0].parentNode.classList.add('active');
					this.targets()[0].classList.add('animated');
					maskTl.restart();
					maskTl.play();
					// console.log("animation started");
					// console.log(this.progress());
					// this.targets()[0].nextElementSibling.classList.toggle('active');
				},
				onComplete() {
					// console.log("animation ended");
					this.targets()[0].parentNode.classList.remove('active');
					// console.log("mask started")
				}
			}
		},
			"start");
	}
});

